import Logo from 'src/assets/logo.svg';

export const AppLoadingSurface = () => (
    <div className="app-loading-surface">
        <div className="app-loading-lockup" role="status" aria-label="Loading ResQ">
            <img className="app-loading-logo" src={Logo} alt="ResQ" />
            <div className="app-loading-spinner" aria-hidden="true" />
        </div>
    </div>
);
